module.exports = __webpack_public_path__ + "static/ghast-c43aa244384c50682a1307c91845780a.jpg";